import { render, staticRenderFns } from "./AdminHoursBookedByLocation.vue?vue&type=template&id=a740dd42"
import script from "./AdminHoursBookedByLocation.vue?vue&type=script&lang=js"
export * from "./AdminHoursBookedByLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports